import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
  DropdownTrigger,
  Selection,
} from '@nextui-org/react';
import React, { useState } from 'react';
import CreateExperimentModal from '../components/create-experiment-modal';

import { Icon } from '@iconify/react';
import { useNavigate, useParams } from 'react-router-dom';
import DataTable from '../../../components/table/data-table';
import { TableConfig } from '../../../components/table/types';
import ExperimentDetails from '../components/experiment-details';

export default function PlaygroundTab() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDatasets, setSelectedDatasets] = useState<Selection>(
    new Set([])
  );
  const [selectedScorers, setSelectedScorers] = useState<Selection>(
    new Set([])
  );
  const [selectedExperiment, setSelectedExperiment] = useState(null);

  const tableConfig: TableConfig = {
    columns: [
      {
        uid: 'name',
        name: 'Name',
      },
      {
        uid: 'errors',
        name: 'Errors',
      },
      {
        uid: 'duration',
        name: 'Duration (avg)',
      },
      {
        uid: 'llmDuration',
        name: 'LLM duration',
      },
      {
        uid: 'promptTokens',
        name: 'Prompt tokens',
      },
      {
        uid: 'completionTokens',
        name: 'Completion tokens',
      },
      {
        uid: 'totalTokens',
        name: 'Total tokens',
      },
      {
        uid: 'creator',
        name: 'Creator',
      },
      {
        uid: 'updated',
        name: 'Updated',
      },
      {
        uid: 'examples',
        name: 'Examples',
      },
      {
        uid: 'source',
        name: 'Source',
      },
    ],
    initialVisibleColumns: [
      'name',
      'errors',
      'duration',
      'llmDuration',
      'promptTokens',
      'completionTokens',
      'totalTokens',
      'creator',
      'updated',
      'examples',
      'source',
    ],
    actions: {
      enableRowSelection: false,
      defaultRowSelection: 'single',
    },
    bottomContentPlacement: 'outside',
    tdClassName: 'py-2.5',
  };

  const tableData = [
    {
      id: '1',
      name: 'Experiment 1',
      errors: '-',
      duration: '-',
      llmDuration: '-',
      promptTokens: '-',
      completionTokens: '-',
      totalTokens: '-',
      creator: 'Srikanth',
      updated: '1h ago',
      examples: '-',
      source: '-',
    },
    {
      id: '2',
      name: 'Experiment 2 ',
      errors: '-',
      duration: '1.5s',
      llmDuration: '2s',
      promptTokens: '12232',
      completionTokens: '-',
      totalTokens: '-',
      creator: 'Srikanth',
      updated: '1h ago',
      examples: '-',
      source: '-',
    },
    // ... add more sample data as needed
  ];

  // Example dataset and scorer options (you can move these to constants if needed)
  const datasets = [
    { key: 'dataset1', label: 'Dataset 1' },
    { key: 'dataset2', label: 'Dataset 2' },
    { key: 'dataset3', label: 'Dataset 3' },
  ];

  // Define the specific scorers
  const specificScorers = [
    {
      category: 'Heuristic',
      items: [
        {
          key: 'json-diff-case-order-path-ztwdcl-ltgria',
          label: 'JSON Diff (Case, order, path)',
        },
        { key: 'json-validity', label: 'JSON Validity' },
      ],
    },
    {
      category: 'Character & Word Count',
      items: [
        { key: 'max-character-length-zqovcc', label: 'Max Character Length' },
        { key: 'word-count-adherence', label: 'Word Count Adherence' },
      ],
    },
    {
      category: 'Uptrain',
      items: [
        {
          key: 'uptrain-guideline-adherence',
          label: 'Uptrain - Guideline Adherence',
        },
        { key: 'uptrain-tonality', label: 'Uptrain - Tonality' },
        {
          key: 'uptrain-jailbreak-detection',
          label: 'Uptrain - Jailbreak Detection',
        },
      ],
    },
    {
      category: 'Ragas',
      items: [
        { key: 'ragas-faithfulness', label: 'Ragas - Faithfulness' },
        { key: 'ragas-context-relevancy', label: 'Ragas - Context Relevancy' },
        { key: 'ragas-answer-relevance', label: 'Ragas - Answer Relevance' },
      ],
    },
    {
      category: 'Matching',
      items: [
        { key: 'regex-match', label: 'Regex Match' },
        { key: 'exact-match', label: 'Exact Match' },
      ],
    },
    {
      category: 'Semantic',
      items: [
        {
          key: 'semantic-similarity-cross-encoder-stsb-roberta-large',
          label: 'Semantic Similarity',
        },
      ],
    },
    // {
    //   category: 'Testing',
    //   items: [{ key: 'test-metric-0', label: 'Test Vellum Metric' }],
    // },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/evaluations/playground/${id}`);
  };

  const handleSelectionChange = (selection: Selection) => {
    setSelectedExperiment(12);
  };

  //   if (selectedExperiment) {
  //     // const experimentId = id || Array.from(selectedExperiment)[0]?.toString();
  //     return (
  //       <ExperimentDetails
  //         id={selectedExperiment}
  //         onBack={() => {
  //           setSelectedExperiment(null);
  //           if (id) {
  //             navigate('/evaluations/playground');
  //           }
  //         }}
  //       />
  //     );
  //   }

  return (
    <div className="space-y-4">
      {!selectedExperiment && (
        <React.Fragment>
          <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:justify-end">
            <div className="flex flex-wrap justify-start gap-2 sm:justify-end">
              <Dropdown size="sm">
                <DropdownTrigger>
                  <Button
                    size="sm"
                    variant="bordered"
                    className="gap-2 border-1"
                  >
                    <Icon icon="material-symbols:database" />
                    Dataset
                    {selectedDatasets.size > 0
                      ? ` (${selectedDatasets.size})`
                      : ''}
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  aria-label="Dataset options"
                  selectionMode="multiple"
                  selectedKeys={selectedDatasets}
                  onSelectionChange={setSelectedDatasets}
                  items={datasets}
                >
                  {(item) => (
                    <DropdownItem key={item.key}>{item.label}</DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>

              <Dropdown size="sm">
                <DropdownTrigger>
                  <Button
                    size="sm"
                    variant="bordered"
                    className="gap-2 border-1"
                  >
                    <Icon icon="material-symbols:percent" />
                    Scorers
                    {selectedScorers.size > 0
                      ? ` (${selectedScorers.size})`
                      : ''}
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  aria-label="Scorer options"
                  selectionMode="multiple"
                  selectedKeys={selectedScorers}
                  onSelectionChange={setSelectedScorers}
                  className="max-h-[60vh] overflow-y-auto"
                >
                  {specificScorers.map((category) => (
                    <DropdownSection
                      key={category.category}
                      title={
                        <span className="font-semibold">
                          {category.category}
                        </span>
                      }
                    >
                      {category.items.map((item) => (
                        <DropdownItem key={item.key}>
                          <span className="text-xs">{item.label}</span>
                        </DropdownItem>
                      ))}
                    </DropdownSection>
                  ))}
                </DropdownMenu>
              </Dropdown>

              <Button
                size="sm"
                variant="bordered"
                onPress={() => setIsModalOpen(true)}
                className="border-1 gap-2"
              >
                <Icon icon="material-symbols:add" />
                Experiment
              </Button>
              <Button
                size="sm"
                color="primary"
                className="hidden gap-2 sm:inline-flex"
              >
                <Icon icon="material-symbols:play-arrow-rounded" />
                Run
              </Button>
            </div>
            <Button size="sm" color="primary" className="gap-2 sm:hidden">
              <Icon icon="material-symbols:play-arrow-rounded" />
              Run
            </Button>
            {/* <Button
          color="primary"
          className="gap-2"
          onPress={() => navigate('/evaluations/playground/new')}
        >
          <Icon icon="material-symbols:add" />
          Playground
        </Button> */}
          </div>

          <DataTable
            config={tableConfig}
            data={tableData}
            onSelectionChange={handleSelectionChange}
          />
          <CreateExperimentModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </React.Fragment>
      )}
      {selectedExperiment && (
        <ExperimentDetails
          id={selectedExperiment}
          onBack={() => {
            setSelectedExperiment(null);
            if (id) {
              navigate('/evaluations/playground');
            }
          }}
        />
      )}
    </div>
  );
}
